import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { saveUser, getUserByEmail, generateUserId, saveCart, getCart } from '../firebase/config';
import './Pages.css';

const Register = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
    state: '',
    city: '',
    pin: '',
    address: '',
    industryArea: '',
    experience: '',
    preferredLocation: ''
  });
  const [error, setError] = useState('');

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleRegister = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError('');

  // Validation
  if (formData.password !== formData.confirmPassword) {
    setError('Passwords do not match!');
    setLoading(false);
    return;
  }

  if (formData.password.length < 6) {
    setError('Password must be at least 6 characters long');
    setLoading(false);
    return;
  }

  // REMOVED: Email uniqueness check - allowing multiple registrations with same email

  // Generate unique user ID
  const userId = generateUserId();

  // Save user data
  const userData = {
    firstName: formData.firstName,
    lastName: formData.lastName,
    email: formData.email,
    phone: formData.phone,
    password: formData.password,
    state: formData.state,
    city: formData.city,
    pin: formData.pin,
    address: formData.address,
    industryArea: formData.industryArea,
    experience: formData.experience,
    preferredLocation: formData.preferredLocation,
    createdAt: new Date().toISOString(),
    userId: userId
  };

  const result = await saveUser(userId, userData);
  setLoading(false);

  if (result.success) {
    // CHECK FOR GUEST CART - Merge with user cart
    const guestId = localStorage.getItem('guestUserId');
    let pendingCartItems = [];
    let cartMerged = false;
    
    // Get guest cart items
    if (guestId) {
      const guestCartData = localStorage.getItem(`cart_${guestId}`);
      if (guestCartData) {
        try {
          const guestCart = JSON.parse(guestCartData);
          if (guestCart.length > 0) {
            pendingCartItems = guestCart;
            cartMerged = true;
          }
        } catch (e) {
          // Invalid JSON
        }
      }
    }
    
    // Also check pendingCartItems from ServicePage
    const pendingItems = localStorage.getItem('pendingCartItems');
    if (pendingItems) {
      try {
        const parsed = JSON.parse(pendingItems);
        if (parsed.length > 0) {
          parsed.forEach(item => {
            if (!pendingCartItems.some(i => i.id === item.id)) {
              pendingCartItems.push(item);
              cartMerged = true;
            }
          });
        }
      } catch (e) {
        // Invalid JSON
      }
    }

    // Get existing user cart from Firebase
    let userCart = [];
    if (pendingCartItems.length > 0) {
      try {
        const userCartResult = await getCart(userId);
        if (userCartResult.success && userCartResult.data) {
          userCart = userCartResult.data;
        }
        
        // Merge guest cart with user cart (avoid duplicates)
        pendingCartItems.forEach(item => {
          if (!userCart.some(i => i.id === item.id)) {
            userCart.push(item);
          }
        });
        
        // Save merged cart to Firebase
        await saveCart(userId, userCart);
        
        // Clear guest cart data
        if (guestId) {
          localStorage.removeItem(`cart_${guestId}`);
        }
        localStorage.removeItem('pendingCartItems');
        localStorage.removeItem('guestUserId');
      } catch (e) {
        console.error('Error merging cart:', e);
      }
    }

    // Store user session
    localStorage.setItem('currentUser', JSON.stringify({ 
      ...userData, 
      userId,
      isLoggedIn: true,
      cartMerged: cartMerged
    }));

    // Show success message with cart info
    const mergeMessage = cartMerged && pendingCartItems.length > 0 
      ? `\n${pendingCartItems.length} item(s) from your guest cart have been saved to your account.`
      : '';
    alert('Registration successful!' + mergeMessage);

    // Navigate to cart if there were items, otherwise home
    if (cartMerged && pendingCartItems.length > 0) {
      navigate('/cart');
    } else {
      navigate('/');
    }
  } else {
    setError('Registration failed: ' + result.error);
  }
};

  // Complete list of industries organized by sector
const industryOptions = {
  'Industry Areas': [
    'Accounting/Finance',
    'Advertising/PR/MR/Events',
    'Animation',
    'Architecture/Interior Designing',
    'Auto/Auto Ancillary',
    'Aviation/Aero Space Firms',
    'Banking/Financial Services Broking',
    'BPO/ITES',
    'Consumer Durables',
    'Courier/Transpotation/Freight',
    'Education/Teaching/Training',
    'Electricals/Switchgears',
    'Export/Import',
    'Facility Management',
    'FMCG/Foods/Beverage',
    'Fresher/Trainee',
    'Glass',
    'Heat Ventilation/Air Conditioning',
    'Hotels/Restaurants/Airlines/Travel',
    'Industrial Products/Heavy Machinery',
    'Insurance',
    'Internet/E-Commerce',
    'IT-Hardware & Networking',
    'IT-Software/Software Services',
    'KPO/Research/Analytics',
    'Legal',
    'Media/Dotcom/Entertainment',
    'Medical/Healthcare/Hospital',
    'Mining',
    'NGO/Social Services',
    'Office Equipment/Automation',
    'Oil & Gas/power?Infrastructure/Energy',
    'OTHER',
    'Paper',
    'Pharma/Biotech/Clinical Research',
    'Printing/Packaging',
    'Real Estate/Property',
    'Recruitment',
    'retail',
    'Security/Law Enforcement',
    'Semiconductor/Electronics',
    'Shiping/Marine',
    'Steel',
    'Strategy management/Consulting Firm',
    'Telecom/ISP',
    'Textile/Garments/Accessories',
    'Tyres',
    'Water treatment/Waste Management',
    'Wellness/Fitness/Sports',
    'OTHER'
  ]
};

// Flatten all industries for select dropdown
const allIndustries = Object.values(industryOptions).flat();


// ============================================================
// COMPLETE PREFERRED LOCATION LIST
// ============================================================

const locationOptions = {

  // ----------------------------------------------------------
  // INDIA - METROS
  // ----------------------------------------------------------

  'Metros': [
    'Ahmedabad',
    'Bengaluru/ Bangalore',
    'Chennai',
    'Delhi',
    'Gurgaon',
    'Hyderabad/ Secunderabad',
    'Kolkata',
    'Mumbai',
    'Noida/ Greater Noida',
    'Pune'
  ],

  // ----------------------------------------------------------
  // UNION TERRITORIES
  // ----------------------------------------------------------

  'Union Territories': [
    'Andaman & Nicobar',
    'Chandigarh',
    'Dadra & Nagar Haveli - Silvassa',
    'Daman & Diu',
    'Delhi',
    'Lakshdweep',
    'Pondicherry/ Puducherry'
  ],

  // ----------------------------------------------------------
  // ANDHRA PRADESH
  // ----------------------------------------------------------

  'Andhra Pradesh': [
    'Anantapur',
    'Guntakal',
    'Guntur',
    'Hyderabad/ Secunderabad',
    'Kakinada',
    'Kurnool',
    'Nellore',
    'Nizamabad',
    'Rajahmundry',
    'Tirupati',
    'Vijayawada',
    'Visakhapatnam',
    'Warangal',
    'Other City(s) in Andhra Pradesh'
  ],

  // ----------------------------------------------------------
  // ARUNACHAL PRADESH
  // ----------------------------------------------------------

  'Arunachal Pradesh': [
    'Itanagar',
    'Other City(s) in Arunachal Pradesh'
  ],

  // ----------------------------------------------------------
  // ASSAM
  // ----------------------------------------------------------

  'Assam': [
    'Bongaigaon',
    'Dhubri',
    'Dibrugarh',
    'Guwahati',
    'Jorhat',
    'Sibsagar',
    'Silchar',
    'Tezpur',
    'Tinsukia',
    'Other City(s) in Assam'
  ],

  // ----------------------------------------------------------
  // BIHAR
  // ----------------------------------------------------------

  'Bihar': [
    'Bhagalpur',
    'Muzaffarpur',
    'Patna',
    'Other City(s) in Bihar'
  ],

  // ----------------------------------------------------------
  // CHHATTISGARH
  // ----------------------------------------------------------

  'Chhattisgarh': [
    'Bhilai-Durg',
    'Bilaspur',
    'Raipur',
    'Other City(s) in Chhattisgarh'
  ],

  // ----------------------------------------------------------
  // GOA
  // ----------------------------------------------------------

  'Goa': [
    'Panjim/ Panaji',
    'Vasco Da Gama',
    'Other City(s) in Goa'
  ],

  // ----------------------------------------------------------
  // GUJARAT
  // ----------------------------------------------------------

  'Gujarat': [
    'Ahmedabad',
    'Anand',
    'Ankleshwar',
    'Bharuch',
    'Bhavnagar',
    'Bhuj',
    'Gandhidham',
    'Gandhinagar',
    'Gir',
    'Jamnagar',
    'Junagarh',
    'Kandla',
    'Mehsana',
    'Porbandar',
    'Rajkot',
    'Surat',
    'Vadodara',
    'Valsad -Vapi',
    'Other City(s) in Gujarat'
  ],

  // ----------------------------------------------------------
  // HARYANA
  // ----------------------------------------------------------

  'Haryana': [
    'Ambala',
    'Bhiwani',
    'Chandigarh',
    'Faridabad',
    'Fatehabad',
    'Gurgaon',
    'Hissar',
    'Jhajjar',
    'Jind',
    'Kaithal',
    'Karnal',
    'Kurukshetra',
    'Mahendergarh',
    'Narnaul',
    'Panchkula',
    'Panipat',
    'Rewari',
    'Rohtak',
    'Sirsa',
    'Sonepat',
    'Yamunanagar',
    'Other City(s) in Haryana'
  ],

  // ----------------------------------------------------------
  // HIMACHAL PRADESH
  // ----------------------------------------------------------

  'Himachal Pradesh': [
    'Baddi',
    'Bilaspur',
    'Chamba',
    'Dalhousie',
    'Dharamshala',
    'Hamirpur',
    'Kangra',
    'Kasauli',
    'Kinnaur',
    'Kullu',
    'Lahaul & Spiti',
    'Manali',
    'Mandi',
    'Nalagarh',
    'Parwanoo',
    'Shimla',
    'Sirmaur',
    'Solan',
    'Una',
    'Other City(s) in Himachal Pradesh'
  ],

  // ----------------------------------------------------------
  // JAMMU & KASHMIR
  // ----------------------------------------------------------

  'Jammu & Kashmir': [
    'Anantnag',
    'Baramulla',
    'Budgam',
    'Doda',
    'Jammu',
    'Kargil',
    'Kathua',
    'Kupwara',
    'Leh',
    'Poonch',
    'Pulwama',
    'Rajouri',
    'Srinagar',
    'Udhampur',
    'Other City(s) in Jammu & Kashmir'
  ],

  // ----------------------------------------------------------
  // JHARKHAND
  // ----------------------------------------------------------

  'Jharkhand': [
    'Bokaro',
    'Dhanbad',
    'Jamshedpur',
    'Ranchi',
    'Other City(s) in Jharkhand'
  ],

  // ----------------------------------------------------------
  // KARNATAKA
  // ----------------------------------------------------------

  'Karnataka': [
    'Belgaum',
    'Bellary',
    'Bengaluru/ Bangalore',
    'Bidar',
    'Davanagere',
    'Dharwad',
    'Gulbarga',
    'Hubli',
    'Kolar',
    'Mangalore',
    'Mysoru/ Mysore',
    'Other City(s) in Karnataka'
  ],

  // ----------------------------------------------------------
  // KERALA
  // ----------------------------------------------------------

  'Kerala': [
    'Calicut/ Kozhikode',
    'Cochin/ Kochi/ Ernakulam',
    'Kannur',
    'Kollam',
    'Kottayam',
    'Palakkad',
    'Thiruvananthapuram',
    'Thrissur',
    'Other City(s) in Kerala'
  ],

  // ----------------------------------------------------------
  // MADHYA PRADESH
  // ----------------------------------------------------------

  'Madhya Pradesh': [
    'Bhopal',
    'Gwalior',
    'Indore',
    'Jabalpur',
    'Katni',
    'Ratlam',
    'Sagar',
    'Satna',
    'Ujjain',
    'Other City(s) in Madhya Pradesh'
  ],

  // ----------------------------------------------------------
  // MAHARASHTRA
  // ----------------------------------------------------------

  'Maharashtra': [
    'Ahmednagar',
    'Akola',
    'Amravati',
    'Aurangabad',
    'Buldhana',
    'Chandrapur',
    'Dhule',
    'Gondia',
    'Jalgaon',
    'Kolhapur',
    'Latur',
    'Lonavala',
    'Mahabaleshwar',
    'Mumbai',
    'Nagpur',
    'Nanded',
    'Nasik',
    'Navi Mumbai',
    'Pune',
    'Sangli',
    'Satara',
    'Solapur',
    'Thane',
    'Yavatmal',
    'Other City(s) in Maharashtra'
  ],

  // ----------------------------------------------------------
  // MANIPUR
  // ----------------------------------------------------------

  'Manipur': [
    'Imphal',
    'Other City(s) in Manipur'
  ],

  // ----------------------------------------------------------
  // MEGHALAYA
  // ----------------------------------------------------------

  'Meghalaya': [
    'Shillong',
    'Other City(s) in Meghalaya'
  ],

  // ----------------------------------------------------------
  // MIZORAM
  // ----------------------------------------------------------

  'Mizoram': [
    'Aizawal',
    'Other City(s) in Mizoram'
  ],

  // ----------------------------------------------------------
  // NAGALAND
  // ----------------------------------------------------------

  'Nagaland': [
    'Dimapur',
    'Kohima',
    'Other City(s) in Nagaland'
  ],

  // ----------------------------------------------------------
  // ORISSA
  // ----------------------------------------------------------

  'Orissa': [
    'Bhubaneshwar',
    'Cuttack',
    'Paradeep',
    'Puri',
    'Rourkela',
    'Other City(s) in Orissa'
  ],

  // ----------------------------------------------------------
  // PUNJAB
  // ----------------------------------------------------------

  'Punjab': [
    'Amritsar',
    'Batala',
    'Bathinda',
    'Chandigarh',
    'Faridkot',
    'Fatehgarh Sahib',
    'Ferozepur',
    'Gurdaspur',
    'Hoshiarpur',
    'Jalandhar',
    'Kapurthala',
    'Ludhiana',
    'Mansa',
    'Moga',
    'Mohali',
    'Muktsar',
    'Nawanshahr',
    'Pathankot',
    'Patiala',
    'Ropar',
    'Sangrur',
    'Other City(s) in Punjab'
  ],

  // ----------------------------------------------------------
  // RAJASTHAN
  // ----------------------------------------------------------

  'Rajasthan': [
    'Ajmer',
    'Alwar',
    'Bikaner',
    'Jaipur',
    'Jaisalmer',
    'Jodhpur',
    'Kota',
    'Udaipur',
    'Other City(s) in Rajasthan'
  ],

  // ----------------------------------------------------------
  // SIKKIM
  // ----------------------------------------------------------

  'Sikkim': [
    'Gangtok',
    'Other City(s) in Sikkim'
  ],

  // ----------------------------------------------------------
  // TAMIL NADU
  // ----------------------------------------------------------

  'Tamil Nadu': [
    'Chennai',
    'Coimbatore',
    'Cuddalore',
    'Erode',
    'Hosur',
    'Kanniyakumari',
    'Madurai',
    'Nagercoil',
    'Ooty',
    'Salem',
    'Thanjavur',
    'Tirunelveli',
    'Trichy',
    'Tuticorin',
    'Vellore',
    'Other City(s) in Tamil Nadu'
  ],

  // ----------------------------------------------------------
  // TRIPURA
  // ----------------------------------------------------------

  'Tripura': [
    'Agartala',
    'Other City(s) in Tripura'
  ],

  // ----------------------------------------------------------
  // UTTAR PRADESH
  // ----------------------------------------------------------

  'Uttar Pradesh': [
    'Agra',
    'Aligarh',
    'Allahabad',
    'Bareilly',
    'Faizabad',
    'Ghaziabad',
    'Gorakhpur',
    'Kanpur',
    'Lucknow',
    'Mathura',
    'Meerut',
    'Moradabad',
    'Muzaffarnagar',
    'Noida/ Greater Noida',
    'Saharanpur',
    'Varanasi / Banaras',
    'Other City(s) in Uttar Pradesh'
  ],

  // ----------------------------------------------------------
  // UTTARANCHAL
  // ----------------------------------------------------------

  'Uttaranchal': [
    'Dehradun',
    'Haldwani',
    'Haridwar',
    'Nainital',
    'Roorkee',
    'Rudrapur',
    'Other City(s) in Uttaranchal'
  ],

  // ----------------------------------------------------------
  // WEST BENGAL
  // ----------------------------------------------------------

  'West Bengal': [
    'Asansol',
    'Burdwan',
    'Durgapur',
    'Haldia',
    'Kharagpur',
    'Kolkata',
    'Malda',
    'Midnapur',
    'Raniganj',
    'Siliguri',
    'Other City(s) in West Bengal'
  ],

  // ==========================================================
  // INTERNATIONAL
  // ==========================================================

  // ----------------------------------------------------------
  // GULF / MIDDLE EAST
  // ----------------------------------------------------------

  'Bahrain': [
    'Manama',
    'Other City(s) in Bahrain'
  ],

  'Egypt': [
    'Cairo',
    'Other City(s) in Egypt'
  ],

  'Kuwait': [
    'Kuwait City',
    'Other City(s) in Kuwait'
  ],

  'Lebanon': [
    'Beirut',
    'Other City(s) in Lebanon'
  ],

  'Oman': [
    'Muscat',
    'Other City(s) in Oman'
  ],

  'Qatar': [
    'Doha',
    'Other City(s) in Qatar'
  ],

  'Saudi Arabia': [
    'Al Madina Al Munawarah',
    'Eastern Province',
    'Jeddah',
    'Other City(s) in Saudi Arabia'
  ],

  'United Arab Emirates': [
    'Abu Dhabi',
    'Al Ain',
    'Ajman',
    'Dubai',
    'Fujairah',
    'Ras Al Khaimah',
    'Sharjah',
    'Um Al Qaiwan',
    'Other City(s) in UAE'
  ],

  'Other Gulf/ Middle East': [
    'Algeria',
    'Iraq',
    'Israel',
    'Jordan',
    'Libya',
    'Morocco',
    'Palestine',
    'Sudan',
    'Syria',
    'Tunisia',
    'Turkey',
    'Yemen',
    'Other Gulf/ Middle East Location(s)'
  ],

  // ----------------------------------------------------------
  // UNITED STATES
  // ----------------------------------------------------------

  'California': [
    'San Francisco',
    'Los Angeles',
    'Other City(s) in California'
  ],

  'Georgia': [
    'Atlanta',
    'Other City(s) in Georgia'
  ],

  'Illinois': [
    'Aurora',
    'Chicago',
    'Elgin',
    'Schaumburg',
    'Other City(s) in Illinois'
  ],

  'Maryland': [
    'Baltimore',
    'Washington DC',
    'Other City(s) in Maryland'
  ],

  'Massachusetts': [
    'Boston',
    'Other City(s) in Massachusetts'
  ],

  'Michigan': [
    'Detroit',
    'Other City(s) in Michigan'
  ],

  'New Jersey': [
    'Jersey City',
    'Newark',
    'Other City(s) in New Jersey'
  ],

  'New York': [
    'New York City',
    'Other City(s) in New York'
  ],

  'North Carolina': [
    'Albany',
    'Charlotte',
    'Raleigh',
    'Other City(s) in North Carolina'
  ],

  'Ohio': [
    'Cincinnati',
    'Other City(s) in Ohio'
  ],

  'Oregon': [
    'Portland',
    'Other City(s) in Oregon'
  ],

  'Pennsylvania': [
    'Philadelphia',
    'Pittsburgh',
    'Other City(s) in Pennsylvania'
  ],

  'Texas': [
    'Dallas',
    'Houston',
    'Plano',
    'Other City(s) in Texas'
  ],

  'Virginia': [
    'Richmond',
    'Sterling',
    'Other City(s) in Virginia'
  ],

  'Washington': [
    'Redmond',
    'Seattle',
    'Other City(s) in Washington'
  ],

  'Other US': [
    'Other US Location(s)'
  ],

  // ----------------------------------------------------------
  // OTHER INTERNATIONAL
  // ----------------------------------------------------------

  'Other International': [
    'Australia',
    'Bangladesh',
    'Belgium',
    'Canada',
    'China',
    'France',
    'Germany',
    'Hong Kong',
    'Indonesia',
    'Ireland',
    'Italy',
    'Japan',
    'Kenya',
    'Malaysia',
    'Maldives',
    'Mauritius',
    'Mexico',
    'Nepal',
    'Netherlands',
    'New Zealand',
    'Norway',
    'Pakistan',
    'Philippines',
    'Quilon',
    'Russia & CIS',
    'Singapore',
    'South Africa',
    'South Korea',
    'Spain',
    'Sri Lanka',
    'Sweden',
    'Switzerland',
    'Thailand',
    'UK',
    'Zimbabwe',
    'Other International Location(s)'
  ]
};




  return React.createElement(
    'main',
    { className: 'page-content' },
    React.createElement(
      'div',
      { className: 'container' },
      // Page Header
      React.createElement(
        'div',
        { className: 'page-header-auth' },
        React.createElement(
          'div',
          { className: 'breadcrumb-auth' },
          React.createElement(
            'a',
            { 
              href: '#',
              onClick: (e) => { e.preventDefault(); handleNavigation('/'); },
              style: { color: '#65d2bc', textDecoration: 'none', cursor: 'pointer' }
            },
            'Home'
          ),
          React.createElement('span', { className: 'separator' }, ' / '),
          React.createElement(
            'a',
            { 
              href: '#',
              onClick: (e) => { e.preventDefault(); handleNavigation('/pages'); },
              style: { color: '#65d2bc', textDecoration: 'none', cursor: 'pointer' }
            },
            'Pages'
          ),
          React.createElement('span', { className: 'separator' }, ' / '),
          React.createElement('span', { style: { color: '#0f172a', fontWeight: '600' } }, 'User Register')
        ),
        React.createElement(
          'div',
          { className: 'page-title-auth' },
          React.createElement('h1', null, 'User Register'),
          React.createElement('span', null, 'User register page')
        )
      ),

      // Register Form
      React.createElement(
        'div',
        { className: 'auth-container register-container' },
        React.createElement(
          'div',
          { className: 'auth-card register-card' },
          React.createElement('h2', null, 'Create Account'),
          error && React.createElement(
            'div',
            { className: 'error-message' },
            error
          ),
          React.createElement(
            'form',
            { onSubmit: handleRegister },
            // First Name & Last Name
            React.createElement(
              'div',
              { className: 'form-row' },
              React.createElement(
                'div',
                { className: 'form-group half' },
                React.createElement('label', null, 'First Name'),
                React.createElement('input', {
                  type: 'text',
                  name: 'firstName',
                  placeholder: 'Enter First Name',
                  value: formData.firstName,
                  onChange: handleChange,
                  required: true,
                  className: 'form-control'
                })
              ),
              React.createElement(
                'div',
                { className: 'form-group half' },
                React.createElement('label', null, 'Last Name'),
                React.createElement('input', {
                  type: 'text',
                  name: 'lastName',
                  placeholder: 'Enter Last Name',
                  value: formData.lastName,
                  onChange: handleChange,
                  required: true,
                  className: 'form-control'
                })
              )
            ),
            // Email & Phone
            React.createElement(
              'div',
              { className: 'form-row' },
              React.createElement(
                'div',
                { className: 'form-group half' },
                React.createElement('label', null, 'Email Address'),
                React.createElement('input', {
                  type: 'email',
                  name: 'email',
                  placeholder: 'Enter Email',
                  value: formData.email,
                  onChange: handleChange,
                  required: true,
                  className: 'form-control'
                })
              ),
              React.createElement(
                'div',
                { className: 'form-group half' },
                React.createElement('label', null, 'Contact Number'),
                React.createElement('input', {
                  type: 'tel',
                  name: 'phone',
                  placeholder: 'Enter Phone Number',
                  value: formData.phone,
                  onChange: handleChange,
                  required: true,
                  pattern: '\\d{10}',
                  maxLength: '10',
                  className: 'form-control'
                })
              )
            ),
            // Password & Confirm Password
            React.createElement(
              'div',
              { className: 'form-row' },
              React.createElement(
                'div',
                { className: 'form-group half' },
                React.createElement('label', null, 'Password'),
                React.createElement('input', {
                  type: 'password',
                  name: 'password',
                  placeholder: 'Enter Password (min 6 chars)',
                  value: formData.password,
                  onChange: handleChange,
                  required: true,
                  minLength: '6',
                  className: 'form-control'
                })
              ),
              React.createElement(
                'div',
                { className: 'form-group half' },
                React.createElement('label', null, 'Retype Password'),
                React.createElement('input', {
                  type: 'password',
                  name: 'confirmPassword',
                  placeholder: 'Retype Password',
                  value: formData.confirmPassword,
                  onChange: handleChange,
                  required: true,
                  className: 'form-control'
                })
              )
            ),
            // State & City
            React.createElement(
              'div',
              { className: 'form-row' },
              React.createElement(
                'div',
                { className: 'form-group half' },
                React.createElement('label', null, 'State'),
                React.createElement('input', {
                  type: 'text',
                  name: 'state',
                  placeholder: 'Enter State',
                  value: formData.state,
                  onChange: handleChange,
                  required: true,
                  className: 'form-control'
                })
              ),
              React.createElement(
                'div',
                { className: 'form-group half' },
                React.createElement('label', null, 'City'),
                React.createElement('input', {
                  type: 'text',
                  name: 'city',
                  placeholder: 'Enter City',
                  value: formData.city,
                  onChange: handleChange,
                  required: true,
                  className: 'form-control'
                })
              )
            ),
            // Pin Code & Address
            React.createElement(
              'div',
              { className: 'form-row' },
              React.createElement(
                'div',
                { className: 'form-group half' },
                React.createElement('label', null, 'Postcode / Zip'),
                React.createElement('input', {
                  type: 'text',
                  name: 'pin',
                  placeholder: 'Enter Pin Code',
                  value: formData.pin,
                  onChange: handleChange,
                  required: true,
                  className: 'form-control'
                })
              ),
              React.createElement(
                'div',
                { className: 'form-group half' },
                React.createElement('label', null, 'Address'),
                React.createElement('textarea', {
                  name: 'address',
                  placeholder: 'Enter Address',
                  value: formData.address,
                  onChange: handleChange,
                  required: true,
                  className: 'form-control',
                  rows: '3'
                })
              )
            ),
            // Industry Area & Experience
            React.createElement(
              'div',
              { className: 'form-row' },
              React.createElement(
                'div',
                { className: 'form-group half' },
                React.createElement('label', null, 'Industry Area'),
                React.createElement('select', {
                  name: 'industryArea',
                  value: formData.industryArea,
                  onChange: handleChange,
                  required: true,
                  className: 'form-control'
                },
                  React.createElement('option', { value: '' }, '--Select Industry--'),
                  allIndustries.map(industry => 
                    React.createElement('option', { key: industry, value: industry }, industry)
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'form-group half' },
                React.createElement('label', null, 'Experience'),
                React.createElement('select', {
                  name: 'experience',
                  value: formData.experience,
                  onChange: handleChange,
                  required: true,
                  className: 'form-control'
                },
                  React.createElement('option', { value: '' }, '--Select Experience--'),
                  React.createElement('option', { value: 'Fresher (0 Years)' }, 'Fresher (0 Years)'),
                  React.createElement('option', { value: 'Below 1 Year' }, 'Below 1 Year'),
                  React.createElement('option', { value: '1-2 Years' }, '1-2 Years'),
                  React.createElement('option', { value: '3-5 Years' }, '3-5 Years'),
                  React.createElement('option', { value: '6-10 Years' }, '6-10 Years'),
                  React.createElement('option', { value: '10-15 Years' }, '10-15 Years'),
                  React.createElement('option', { value: '15-20 Years' }, '15-20 Years'),
                  React.createElement('option', { value: 'Above 20 Years' }, 'Above 20 Years')
                )
              )
            ),
            // Preferred Location
            // Preferred Location
React.createElement(
  'div',
  { className: 'form-row' },
  React.createElement(
    'div',
    { className: 'form-group full' },

    React.createElement(
      'label',
      null,
      'Preferred Location'
    ),

    React.createElement(
      'select',
      {
        name: 'preferredLocation',
        value: formData.preferredLocation,
        onChange: handleChange,
        required: true,
        className: 'form-control'
      },

      // Default option
      React.createElement(
        'option',
        { value: '' },
        '--Select Preferred Location--'
      ),

      // Automatically create ALL optgroups
      Object.entries(locationOptions).map(
        ([groupName, cities]) =>
          React.createElement(
            'optgroup',
            {
              key: groupName,
              label: groupName
            },

            cities.map(
              (city, index) =>
                React.createElement(
                  'option',
                  {
                    key: `${groupName}-${city}-${index}`,
                    value: city
                  },
                  city
                )
            )
          )
      )
    )
  )
),
            // Submit Button
            React.createElement(
              'div',
              { className: 'form-row' },
              React.createElement(
                'div',
                { className: 'form-group full' },
                React.createElement(
                  'button',
                  { 
                    type: 'submit',
                    className: 'btn-primary',
                    disabled: loading,
                    style: { width: '100%' }
                  },
                  loading ? React.createElement(React.Fragment, null, React.createElement('i', { className: 'fas fa-spinner fa-spin' }), ' Registering...') : 'Register New Account'
                )
              )
            ),
            React.createElement(
              'p',
              { className: 'auth-link' },
              'Already have an account? ',
              React.createElement(
                'span',
                {
                  onClick: () => handleNavigation('/login'),
                  style: { color: '#65d2bc', cursor: 'pointer', fontWeight: '600' }
                },
                'Login'
              )
            ),
            React.createElement(
              'button',
              {
                type: 'button',
                className: 'btn-secondary',
                onClick: () => handleNavigation('/'),
                style: { width: '100%', marginTop: '8px' }
              },
              React.createElement('i', { className: 'fas fa-arrow-left' }),
              ' Back to Home'
            )
          )
        )
      )
    )
  );
};

export default Register;